import { Balance, Cashflow, SyndesiCategories } from '../types/cashflow';
import { clientWithoutInterceptors } from '../utils/http';

export async function getHasCashflow(): Promise<Response> {
  const response = await clientWithoutInterceptors.get('/api/cashflows/meta/v2/has-cashflow');
  return response.data;
}

export async function getisFinishedLoadingCashflow(): Promise<Response> {
  const response = await clientWithoutInterceptors.get('/api/onboarding-state-v2/is-finished-loading-cashflow');
  return response.data;
}

export async function getCustomerCredentials(): Promise<Response> {
  const response = await clientWithoutInterceptors.get('/api/v2/customer-creds');
  return response.data;
}

export async function getCashflowByMonth(cashflowMonth: string): Promise<Cashflow> {
  const response = await clientWithoutInterceptors.get(`/api/cashflows/v2/${cashflowMonth}`);
  return response.data;
}

export async function getBalances(): Promise<Balance[]> {
  const response = await clientWithoutInterceptors.get('/api/balances');
  return response.data;
}

export async function getSyndesiCategories(): Promise<SyndesiCategories> {
  const response = await clientWithoutInterceptors.get('/api/calc-syndesi-categories');
  return response.data;
}
